import { SecretaryDoctorsLayout } from 'presentation/doctor/layouts/SecretaryDoctors'
import React from 'react'

export const SecretaryDoctors = () => {
  return <SecretaryDoctorsLayout />
}

export default SecretaryDoctors
